import { createFileRoute } from "@tanstack/react-router";
import ComoFunciona, { comoFuncionaHowTo } from "@/pages/ComoFunciona";
import { landingHead } from "@/lib/landingHead";

export const Route = createFileRoute("/en/how-it-works")({
  head: () => {
    const h = landingHead("howItWorks", "en");
    const img = "https://retaillemon.com/og-como-funciona.jpg";
    return {
      meta: [
        ...h.meta,
        { property: "og:image", content: img },
        { property: "og:image:width", content: "1200" },
        { property: "og:image:height", content: "630" },
        { property: "og:image:alt", content: "Shop owner checking her accounts at closing time" },
        { property: "og:site_name", content: "Retail Lemon" },
        { name: "twitter:image", content: img },
      ],
      scripts: [{ type: "application/ld+json", children: JSON.stringify(comoFuncionaHowTo("en")) }],
    };
  },
  component: () => <ComoFunciona routeLang="en" />,
});
